import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { StyleService } from '../../services/style.service';
@Component({
  selector: 'app-date-picker',
  template: `
<div class="hazard-description" [formGroup]="group" *ngIf="field.style.visibility && !field.dynamic">
  <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
  <div [ngStyle]="_styleService.applyStyle(field)" [ngClass]="{'pointer-events' : !field.style.editability}" class="date-fixed-on flt-select-style" (click)="picker.open()">
    <input [matDatepicker]="picker" class="form-control" [min]="(field.id === 'hDueDate') ? myDate : ''" [max]="(field.id === 'fixedOn' || field.id === 'reportedOn')  ? myDate : ''" (dateInput)="addEvent('input', $event)">
    <p>{{ (field.value !== '' && field.value !== undefined) ?  (field.value | amLocal | amDateFormat :'MMM DD, YYYY') : 'Date' }}</p>
    <mat-datepicker #picker></mat-datepicker>
  </div>
  <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
  <div class="hazard-description dynamic-property" [formGroup]="group" *ngIf="field.dynamic && field.style.visibility" [ngClass]="{'pointer-events' : !field.style.editability}">
    <p class="dynamic-paragraph">{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
    <div *ngFor="let x of field.value; let i = index;trackBy:trackByIndex;" class="inputfields">
      <div class="date-fixed-on flt-select-style" (click)="picker.open()">
        <input [matDatepicker]="picker" class="form-control dynamic-input" (dateInput)="addEventDynamic('input', $event,i)">
        <ng-container *ngIf="deleteShow">
        <div class="btn delete-item time-picker-dynamic" (click)="deletShortText(i)"><img src="assets/rff-images/delete-dynamic.svg"></div>
        </ng-container>
          <p>{{ (field.value[i] !== '' && field.value[i] !== undefined) ?  (field.value[i] | amLocal | amDateFormat :'MMM DD, YYYY') : 'Date' }}</p>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
      </div>
      <div class="btn-dynamic">
        <div class="btn btn-default" (click)="dynamicShortText()"><img src="assets/rff-images/add-img.svg"> Add another field</div>
      </div>
      </div>
      `,
  styles: [`.date-fixed-on{background: url(assets/rff-images/calender1.png) no-repeat 97% 54%;}::ng-deep .cdk-overlay-container{z-index:1100}`]
})
export class DatePickerComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  deleteShow = false;
  constructor(
    private _validationService: ValidationService,
    private  _styleService : StyleService
  ) { }
  myDate = new Date();
  addEvent(type: any, event: MatDatepickerInputEvent<Date>) {
    this.field.value = event.value;
    this.getDate();
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  };
  getDate() {
    var utcDate
    if (this.field.value) {
      utcDate = this.field.value
    } else {
      utcDate = new Date();
    }
    let getDate = {
      day: utcDate.getDate(),
      month: utcDate.getMonth() + 1,
      year: utcDate.getFullYear()
    }
    const momentObj = moment(new Date());
    const momentString = momentObj.format('THH:mm:ss.SSSZ');
    const month = (((getDate.month + '').length > 1) ? (getDate.month) : ('0' + getDate.month));
    const day = (((getDate.day + '').length > 1) ? (getDate.day) : ('0' + getDate.day));;
    this.field.value = getDate.year + '-' + month + '-' + day + momentString;
    return this.field.value;
  }
  // dynamic date picker
  addEventDynamic(type: any, event: MatDatepickerInputEvent<Date>, index) {
    this.field.value = Object.assign([], this.field.value, {
      [index]: event.value
    });
    this.getDynamicDate(index, true);
    this.group.value[this.field.id] = this.field.value;
  };
  getDynamicDate(i, type) {
    var utcDate
    if (type) {
      if (this.field.value) {
        utcDate = new Date(this.field.value[i]), i;
      } else {
        utcDate = new Date(), i;
      }
    } else {
      utcDate = new Date(), i
    }
    let getDate = {
      day: utcDate.getDate(),
      month: utcDate.getMonth() + 1,
      year: utcDate.getFullYear()
    }
    const momentObj = moment(new Date());
    const momentString = momentObj.format('THH:mm:ss.SSSZ');
    const month = (((getDate.month + '').length > 1) ? (getDate.month) : ('0' + getDate.month));
    const day = (((getDate.day + '').length > 1) ? (getDate.day) : ('0' + getDate.day));;
    let utcDates = getDate.year + '-' + month + '-' + day + momentString;
    if (type) {
      this.field.value = Object.assign([], this.field.value, {
        [i]: utcDates
      });
    }
    return utcDates;
  }
  trackByIndex(index: number) {
    return index;
  }
  dynamicShortText() {
    this.field.value.push(this.getDynamicDate(0, false));
    this.deleteShow = true;
  }
  deletShortText(i) {
    this.field.value.splice(i, 1);
    if (i === 1) {
      this.deleteShow = false;
    }
  }
  ngOnInit() {
    if (!this.field.dynamic && this.field.value === undefined && ((this.field.default && this.field.default.type === "current") || !this.field.default)) {
      this.field.value = this.getDate();
    }
    if (this.field.dynamic && this.field.value === undefined) {
      this.field.value = [this.getDynamicDate(0, false)];
    }
    if (this.field.dynamic && this.field.value.length > 1) {
      this.deleteShow = true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/rFF/fields/date-picker/date-picker.component.ts